<template>
  <div>
    <vs-popup :title="title" :active.sync="opened" class="sizePopup">
      <vs-input name="description" v-validate="'required'" class="mb-4 w-full" label-placeholder="Descrição" v-model="description"></vs-input>

      <div class="mb-4">
        <div class="w-full mt-4 flex">
          <span>Exibir Campo de Observação?</span>
        </div>
        <div class="w-full mt-4 flex">
          <vs-switch v-model="showObservation">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>

        <div v-if="showObservation">
          <div class="w-full mt-4 flex">
            <span>Observação Obrigatória?</span>
          </div>
          <div class="w-full mt-4 flex">
            <vs-switch v-model="requireObservation">
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
      </div>

      <p><strong>Opções:</strong></p>

      <p class="mb-4" v-if="options.length === 0">Nenhuma opção cadastrada</p>

      <component
        v-for="(option, index) in options"
        :key="index"
        :is="option"
      />

      <vs-button type="flat" @click.prevent="addOption">Adicionar Opção</vs-button>

      <div class="w-full d-flex justify-content-flex-end">
        <vs-button @click.prevent="send">Salvar</vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
  import requests from '@/http/requests/reasons'
  import ReasonOptionForm from '@/views/reason-options/Form'

  export default {
    name: 'reasons-form-popup',
    components: {
      ReasonOptionForm
    },
    data() {
      return {
        options: [],
        opened: false,
        description: '',
        showObservation: false,
        requireObservation: false,
        showValue: false,
        reason: null,
      }
    },
    created () {
      this.$parent.$on('openReasonFormModal', (reason) => {
        this.reason = reason;

        if (this.reason) {
          this.description = this.reason.description;
          this.showValue = this.reason.show_value;
        } else {
          this.description = '';
          this.showValue = false;
        }

        this.open();
      })
    },
    computed: {
      title () {
        if (this.reason) {
          return "Editar Métrica Inteligente"
        } else {
          return "Nova Métrica Inteligente"
        }
      }
    },
    methods: {
      addOption () {
        this.options.push(ReasonOptionForm);
      },
      send () {
        if (this.reason) {
          this.update(this.reason);
        } else {
          this.create();
        }
      },
      update (r) {
        this.$store.dispatch('setShowLoadingOverlay', true)

        let args = {
          description: this.description
        }

        requests.update(r.id, args).then(() => {
          this.$store.dispatch('setShowLoadingOverlay', false);
          this.$emit('reloadReasons');
          this.close();
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'Métrica Inteligente foi atualizada com sucesso'
          })
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          console.log(error)
        })
      },
      create () {
        this.$store.dispatch('setShowLoadingOverlay', true)

        let args = {
          description: this.description,
          showValue: this.showValue
        }

        requests.create(args).then(() => {
          this.description = '';
          this.showValue = false;
          this.$store.dispatch('setShowLoadingOverlay', false);
          this.$emit('reloadReasons');
          this.close();
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'Métrica Inteligente foi criada com sucesso'
          })
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          console.log(error)
        })

      },
      open () {
        this.opened = true;
      },
      close () {
        this.opened = false;
      },
    },
  }
</script>

